import { CtaButton } from '@cred/react-button'
import emitOnClick from '@cred/react-analytics/hoc/emitOnClick'
import withCtaClickEvent from '@cred/react-analytics/hoc/withCtaClickEvent'
import emitGAOnClick from '@cred/shared/hoc/emitGAOnClick'

import withNofollow from 'components/hocs/with-nofollow'

const CtaButtonWithAnalytics = withCtaClickEvent(
  emitOnClick(emitGAOnClick(withNofollow(CtaButton))),
)

export default CtaButtonWithAnalytics
